import {
  call,
  delay,
  race,
  select,
  take,
  takeLatest,
} from 'redux-saga/effects';
import { LOGGED_IN, LOGGED_OUT } from '../modules/auth/actions';
import { SAGA_REBUILD } from '../util/sagas';
import { isLoggedIn } from '../apps/main/rootReducer';
import fetchWithRetry from '../util/fetchWithRetry';
import { apiUrl } from '../api';
import { getAccessToken } from '../store/authEffect';

async function sendKeepAlivePing(abortController: AbortController | null) {
  await fetchWithRetry(`${apiUrl}/PrioHealth/PrioHealthStatus/keepAlive`, {
    headers: {
      Authorization: `Bearer ${await getAccessToken()}`,
    },
    method: 'POST',
    signal: abortController ? abortController.signal : undefined,
  });
}

function* mainTask() {
  try {
    const loggedIn = yield select(isLoggedIn);
    if (loggedIn) {
      yield race([
        call(function* () {
          // one minute delay
          yield delay(60 * 1000);
          let abortController: AbortController | null = null;
          while (true) {
            if (!abortController) {
              abortController = new AbortController();
            }
            yield call(sendKeepAlivePing, abortController);
            // 20 minutes delay
            yield delay(20 * 60 * 1000);
          }
        }),
        take(LOGGED_OUT),
      ]);
    }
  } catch (error) {
    console.error('Error in keepAliveSaga - mainTask', error);
    yield mainTask();
  }
}

export default function* keepAliveSaga() {
  yield takeLatest([LOGGED_IN, SAGA_REBUILD], mainTask);
}
